// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"0c7ad38a","682":"dd4b8953","935":"442f2876"}[chunkId] + ".chunk.css";
};